"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useValueChooserLoader = exports.initLoaderState = void 0;
const react_hooks_1 = require("@apollo/react-hooks");
const doNothing_1 = __importDefault(require("@opsbase/lib-general/utils/doNothing"));
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const uniqBy_1 = __importDefault(require("lodash/uniqBy"));
const react_1 = require("react");
function initLoaderState(partial) {
    return Object.assign({ type: undefined, fieldName: undefined, keyword: undefined, extraValues: [], offset: 0, limit: 25 }, partial);
}
exports.initLoaderState = initLoaderState;
const makeVariables = (state) => {
    return {
        type: state.type,
        extraValues: state.extraValues || [],
        fieldName: state.fieldName,
        keyword: state.keyword,
        offset: state.offset || 0,
        limit: state.limit || 25,
    };
};
function useValueChooserLoader(state) {
    var _a, _b;
    const { keyword, extraValues } = state;
    const variables = makeVariables(state);
    const currentItems = (0, react_1.useRef)([]);
    const result = (0, react_1.useMemo)(() => ({
        totalCount: 0,
        loading: false,
        items: [],
        refetch: doNothing_1.default,
    }), []);
    const gqlStr = (0, graphql_tag_1.default) `
		query VALUESEARCH(
			$type: String!
			$offset: Int
			$limit: Int
			$fieldName: String
			$keyword: String
		) {
			valueSearch(
				type: $type
				offset: $offset
				limit: $limit
				fieldName: $fieldName
				keyword: $keyword
			) {
				offset
				limit
				totalCount
				items
			}
		}
	`;
    const { loading, data, refetch } = (0, react_hooks_1.useQuery)(gqlStr, { variables });
    result.loading = loading;
    result.refetch = refetch;
    if (!loading) {
        result.totalCount = ((_a = data === null || data === void 0 ? void 0 : data.valueSearch) === null || _a === void 0 ? void 0 : _a.totalCount) || 0;
        result.items = ((_b = data === null || data === void 0 ? void 0 : data.valueSearch) === null || _b === void 0 ? void 0 : _b.items) || [];
        if (!keyword) {
            result.items = (0, uniqBy_1.default)([...(extraValues || []), ...currentItems.current, ...result.items], v => v);
        }
        currentItems.current = result.items;
    }
    return result;
}
exports.useValueChooserLoader = useValueChooserLoader;
exports.default = useValueChooserLoader;
